import React, { useCallback, useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/react-hooks';
import { WIDGET_ACCOMMODATIONS } from '../../../graphql/queries/accommodations';
import { CATEGORY_PRICES, DAILY_PRICES, FIXED_PRICES, FUTURE_PRICES } from '../constants';
import { getPrices } from '../../../utils/accommodations-and-activities/prepareReceivedAccommodationData';
import moment from 'moment';

export const useAccommodationsInfiniteQuery = ({ startDate, endDate, guests, ownerId }, skip) => {
  const [page, setPage] = useState(0);
  const [accommodations, setAccommodations] = useState(null);
  const [fetchMore, { loading, data }] = useLazyQuery(WIDGET_ACCOMMODATIONS, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    onCompleted: (accData) => {
      if (!accData || !accData.accommodations) return;

      const newAccommodations = accData.accommodations.map(item => {
        if (item.pricesType) {
          return item;
        }

        let priceType = FUTURE_PRICES || FIXED_PRICES;

        if(item?.futurePrices[0]?.ratePlanPrices){
          priceType = FUTURE_PRICES
        } else if (item.prices[0].participant.participant) {
          priceType = CATEGORY_PRICES;
        } else if (item.prices[0].day) {
          priceType = DAILY_PRICES;
        }

        return {
          ...item,
          ...getPrices(item),
          pricesType: priceType
        };
      });

      if (accommodations?.length) {
        setPage(page + 1);
      }

      setAccommodations([...(accommodations || []), ...newAccommodations]);
    }
  });

  const fetchData = useCallback((requestedPage) => {
    const variables = {
      page: requestedPage ?? 0,
      businessOwnerId: ownerId,
      numberOfAccommodationPerPage: 9,
      startPeriod: startDate && moment(startDate).format('YYYY-MM-DD'),
      endPeriod: endDate && moment(endDate).format('YYYY-MM-DD')
    };

    if (guests) {
      variables.guestsNumber = guests;
    }

    fetchMore({ variables });
  }, [guests, ownerId, startDate, endDate]);

  useEffect(() => {
    if (!skip) {
      fetchData(0);
    }
  }, []);

  useEffect(() => {
    if (!startDate || !endDate) return;
    setAccommodations([]);
    fetchData(0);
    setPage(0);
  }, [startDate, endDate]);

  useEffect(() => {
    // was moving this logic, needs to be reviewed/tested as startDate and endDate are not in dependency array
    if (guests && startDate && endDate) {
      setAccommodations([]);
      fetchData(0);
      setPage(0);
    }
  }, [guests]);

  return {
    accommodationsPage: page,
    accommodations,
    fetchAccommodationsData: fetchData,
    loading,
    perPage: data ? data.numberOfAccommodationsPages - 1 : 0
  }
}
